<template>
  <!-- Header -->
  <BotEditorSubHeader
    :title="$t('botEditor.tabs.deploy')"
    :subtitle="$t('botEditor.deploy.deploySubtitle')"
  />

  <div class="flex flex-col gap-8">
    <!-- Tab Navigation: only the TabList (underline and active colour from the theme).
         The content below stays a keep-alive switch rather than TabPanels, which would
         mount both views at once and add their own padding and background. -->
    <Tabs v-model:value="activeTab">
      <TabList>
        <Tab id="btn-tab-widget-config" value="widget" aria-controls="deploy-tab-content">
          <span class="flex items-center gap-2">
            <span class="material-icons" style="font-size: 18px" aria-hidden="true">settings</span>
            {{ $t('botEditor.deploy.widgetConfig') }}
          </span>
        </Tab>
        <Tab id="btn-tab-snapshots" value="snapshots" aria-controls="deploy-tab-content">
          <span class="flex items-center gap-2">
            <span class="material-icons" style="font-size: 18px" aria-hidden="true">history</span>
            {{ $t('botEditor.deploy.snapshotsTab') }}
          </span>
        </Tab>
      </TabList>
    </Tabs>

    <!-- Tab Content (the tabpanel the two Tabs point at, since there are no TabPanels) -->
    <div
      id="deploy-tab-content"
      role="tabpanel"
      :aria-labelledby="activeTab === 'widget' ? 'btn-tab-widget-config' : 'btn-tab-snapshots'"
      class="mt-6"
    >
      <keep-alive>
        <DeployWidgetConfig v-if="activeTab === 'widget'" />
        <DeploySnapshots v-else-if="activeTab === 'snapshots'" />
      </keep-alive>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import BotEditorSubHeader from '../../components/ui/BotEditorSubHeader.vue';
import DeployWidgetConfig from './DeployWidgetConfig.vue';
import DeploySnapshots from './DeploySnapshots.vue';

const activeTab = ref('widget');
</script>
